/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateSettingRequest,
  GetContactListResponse,
  GetSettingResponse,
  ProblemDetails,
  Result,
  SubmitFormRequest,
  UpdateSettingRequest,
} from '../models/index';
import {
    CreateSettingRequestFromJSON,
    CreateSettingRequestToJSON,
    GetContactListResponseFromJSON,
    GetContactListResponseToJSON,
    GetSettingResponseFromJSON,
    GetSettingResponseToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    ResultFromJSON,
    ResultToJSON,
    SubmitFormRequestFromJSON,
    SubmitFormRequestToJSON,
    UpdateSettingRequestFromJSON,
    UpdateSettingRequestToJSON,
} from '../models/index';

export interface ApiContactRecipientsGetRequest {
    xTenantID?: number;
}

export interface ApiContactSubmitFormPostRequest {
    submitFormRequest: SubmitFormRequest;
    xTenantID?: number;
}

export interface ApiGlobalSettingsByGroupGetRequest {
    group?: string;
    xTenantID?: number;
}

export interface ApiGlobalSettingsByKeyDeleteRequest {
    key?: string;
    xTenantID?: number;
}

export interface ApiGlobalSettingsByKeyGetRequest {
    key?: string;
    xTenantID?: number;
}

export interface ApiGlobalSettingsGetRequest {
    xTenantID?: number;
}

export interface ApiGlobalSettingsPostRequest {
    createSettingRequest: CreateSettingRequest;
    xTenantID?: number;
}

export interface ApiGlobalSettingsPutRequest {
    updateSettingRequest: UpdateSettingRequest;
    xTenantID?: number;
}

/**
 * 
 */
export class GlobalApi extends runtime.BaseAPI {

    /**
     * List of recipients used in contact form
     */
    async apiContactRecipientsGetRaw(requestParameters: ApiContactRecipientsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetContactListResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/contact-recipients`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetContactListResponseFromJSON));
    }

    /**
     * List of recipients used in contact form
     */
    async apiContactRecipientsGet(requestParameters: ApiContactRecipientsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetContactListResponse>> {
        const response = await this.apiContactRecipientsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Submit contact form
     */
    async apiContactSubmitFormPostRaw(requestParameters: ApiContactSubmitFormPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters['submitFormRequest'] == null) {
            throw new runtime.RequiredError(
                'submitFormRequest',
                'Required parameter "submitFormRequest" was null or undefined when calling apiContactSubmitFormPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/contact/submit-form`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SubmitFormRequestToJSON(requestParameters['submitFormRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Submit contact form
     */
    async apiContactSubmitFormPost(requestParameters: ApiContactSubmitFormPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.apiContactSubmitFormPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get global-settings by group. For example, all settings related to \'CONTACT\' can be grouped together with group name \'CONTACT\'.
     * Get global-settings by group
     */
    async apiGlobalSettingsByGroupGetRaw(requestParameters: ApiGlobalSettingsByGroupGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetSettingResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['group'] != null) {
            queryParameters['group'] = requestParameters['group'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/global-settings/by-group`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSettingResponseFromJSON));
    }

    /**
     * Get global-settings by group. For example, all settings related to \'CONTACT\' can be grouped together with group name \'CONTACT\'.
     * Get global-settings by group
     */
    async apiGlobalSettingsByGroupGet(requestParameters: ApiGlobalSettingsByGroupGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetSettingResponse>> {
        const response = await this.apiGlobalSettingsByGroupGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete global-setting by key. For example, if you want to delete the setting with key \'CONTACT_EMAIL\', you can use this endpoint with key \'CONTACT_EMAIL\'.
     * Delete global-setting by key
     */
    async apiGlobalSettingsByKeyDeleteRaw(requestParameters: ApiGlobalSettingsByKeyDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['key'] != null) {
            queryParameters['key'] = requestParameters['key'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/global-settings/by-key`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete global-setting by key. For example, if you want to delete the setting with key \'CONTACT_EMAIL\', you can use this endpoint with key \'CONTACT_EMAIL\'.
     * Delete global-setting by key
     */
    async apiGlobalSettingsByKeyDelete(requestParameters: ApiGlobalSettingsByKeyDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiGlobalSettingsByKeyDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Get global-setting by key. For example, if you want to get the value of \'CONTACT_EMAIL\', you can use this endpoint with key \'CONTACT_EMAIL\'.
     * Get global-setting by key
     */
    async apiGlobalSettingsByKeyGetRaw(requestParameters: ApiGlobalSettingsByKeyGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSettingResponse>> {
        const queryParameters: any = {};

        if (requestParameters['key'] != null) {
            queryParameters['key'] = requestParameters['key'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/global-settings/by-key`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSettingResponseFromJSON(jsonValue));
    }

    /**
     * Get global-setting by key. For example, if you want to get the value of \'CONTACT_EMAIL\', you can use this endpoint with key \'CONTACT_EMAIL\'.
     * Get global-setting by key
     */
    async apiGlobalSettingsByKeyGet(requestParameters: ApiGlobalSettingsByKeyGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSettingResponse> {
        const response = await this.apiGlobalSettingsByKeyGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all global-settings. This endpoint can be used to retrieve all global settings at once.
     * Get all global-settings
     */
    async apiGlobalSettingsGetRaw(requestParameters: ApiGlobalSettingsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetSettingResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/global-settings`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSettingResponseFromJSON));
    }

    /**
     * Get all global-settings. This endpoint can be used to retrieve all global settings at once.
     * Get all global-settings
     */
    async apiGlobalSettingsGet(requestParameters: ApiGlobalSettingsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetSettingResponse>> {
        const response = await this.apiGlobalSettingsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create global-setting
     */
    async apiGlobalSettingsPostRaw(requestParameters: ApiGlobalSettingsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createSettingRequest'] == null) {
            throw new runtime.RequiredError(
                'createSettingRequest',
                'Required parameter "createSettingRequest" was null or undefined when calling apiGlobalSettingsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/global-settings`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSettingRequestToJSON(requestParameters['createSettingRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create global-setting
     */
    async apiGlobalSettingsPost(requestParameters: ApiGlobalSettingsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiGlobalSettingsPostRaw(requestParameters, initOverrides);
    }

    /**
     * Update global-setting
     */
    async apiGlobalSettingsPutRaw(requestParameters: ApiGlobalSettingsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateSettingRequest'] == null) {
            throw new runtime.RequiredError(
                'updateSettingRequest',
                'Required parameter "updateSettingRequest" was null or undefined when calling apiGlobalSettingsPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/global-settings`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSettingRequestToJSON(requestParameters['updateSettingRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update global-setting
     */
    async apiGlobalSettingsPut(requestParameters: ApiGlobalSettingsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiGlobalSettingsPutRaw(requestParameters, initOverrides);
    }

}
